import { render, staticRenderFns } from "./PayPalCasesTable.vue?vue&type=template&id=711a2890&scoped=true"
import script from "./PayPalCasesTable.vue?vue&type=script&lang=js"
export * from "./PayPalCasesTable.vue?vue&type=script&lang=js"
import style0 from "./PayPalCasesTable.vue?vue&type=style&index=0&id=711a2890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711a2890",
  null
  
)

export default component.exports